import { LEVELS } from '../Const';

export const CKMapping = {
  netCashInflowsoutflowsFromOperatingActivies: 'cfa18',
  operatingProfitlossBeforeChangesInWc: 'operatingProfitlossBeforeChangesInWc',
  netProfitlossBeforeTax: 'cfa1',
  adjustment: 'cfs165',
  depreciationAndAmortisation: 'cfa2',
  amortisationOfGoodwill: 'cfa103',
  provisions: 'cfa3',
  unrealisedForeignExchangeGainloss: 'cfa4',
  accruedExpenses: 'cfs166',
  profitlossFromInvestingActivities: 'cfa6',
  interestExpense: 'cfa7',
  interestIncomeAndDividend: 'cfa8',
  otherAdjustments: 'cfa104',
  increaseInNoncashExpense: 'cfs167',
  lossOnValuationOfFairValueThroughProfitlossFinancialAssets: 'cfs168',
  lossFromFinancialAssetsSales: 'cfs169',
  lossFromDerivatives: 'cfs170',
  lossOnValuationOfAvailableForSaleFinancialAssets: 'cfs171',
  decreaseInTheValueOfAvailableSalesAssets: 'cfs172',
  lossOnValuationOfHeldToMarturityInvestments: 'cfs173',
  lossOnTheDecreaseInValueOfLoansGiven: 'cfs174',
  lossRegconizedWhenReclassificationOfAfsIsMadeAndFairValueIsUsedForRevaluation:
    'cfs175',
  lossFromDerivatives_22: 'cfs176',
  lossFromSalesOfFixedAssets: 'cfs177',
  decreaseInValueOfFixedAssets: 'cfs178',
  provisionForDecreaseInValueOfLongtermFinancialInvestments: 'cfs179',
  lossFromDisposalsOrSalesOfInvestmentInSubsidiariesAssociatesAndJointVentures:
    'cfs180',
  otherLoss: 'cfs181',
  decreaseInNoncashRevenue: 'cfs182',
  gainFromRevaluationOfFairValueThroughProfitAndLossFinancialAssets: 'cfs183',
  gainFromRevaluationOfFairValueThroughProfitAndLossFinancialDebts: 'cfs184',
  gainFromSalesOfAvailableForSaleAssets: 'cfs185',
  reversalOfLossFromAvailableForSaleAssets: 'cfs186',
  gainRecognizedWhenReclassificationOfAfsIsMadeAndFairValueIsUsedForRevaluation:
    'cfs187',
  gainFromDerivatives: 'cfs188',
  gainFromTheDecreaseInValueOfLoansGiven: 'cfs189',
  reversalOfProvision: 'cfs190',
  gainFromSalesOfFixedAssetsAndProperties: 'cfs191',
  gainFromDisposalsOrSalesOfInvestmentsInSubsidiariesAssociatesAndJointVentures:
    'cfs192',
  otherGain: 'cfs193',
  changeInAssetsAndOperatingLiabilities: 'cfs194',
  increaseDecreaseInFairValueThroughProfitAndLossFinancialAssets: 'cfs195',
  increaseDecreaseInHeldToMarturityInvestments: 'cfs196',
  increaseDecreaseInLoansGiven: 'cfs197',
  increaseDecreaseInAvailableforsaleFinancialAssets: 'cfs198',
  increaseDecreaseInOtherAssets: 'cfs199',
  increaseDecreaseInReceivableFromSellingFinancialAssets: 'cfs200',
  increaseDecreaseInFinancialAssetLoansAndFinancialLease: 'cfs201',
  increaseDecreaseInFinancialAssetLoans: 'cfs202',
  increaseDecreaseInCovertibleBondequityPortion: 'cfs203',
  increaseDecreaseInIssuedBond: 'cfs204',
  increaseDecreaseInBorrowingFromSettlementAssistanceFund: 'cfs205',
  IncreaseDecreaseInReceivableFromSellingFvtplFinancialAssets: 'cfs206',
  IncreaseDecreaseInReceivableFromInterestsOfFinancialAssets: 'cfs207',
  IncreaseDecreaseInReceivableFromServicesRendered: 'cfs208',
  IncreaseDecreaseInReceibleFromTransactionErrors: 'cfs209',
  IncreaseDecreaseInOtherReceivables: 'cfa10',
  IncreaseDecreaseInExpensePayableNotIncludingInterestExpense: 'cfs223',
  IncreaseDecreaseInTradePayables: 'cfs210',
  IncreaseDecreaseInPayablesToSecuritiesIssuers: 'cfs211',
  IncreaseDecreaseInContributionToEmployeesWelfare: 'cfs212',
  IncreaseDecreaseInTaxAndPayablesToAuthority: 'cfs213',
  IncreaseDecreaseInPayablesToEmployees: 'cfs214',
  IncreaseDecreaseInPayableAriseFromFinancialAssetTransactionErrors: 'cfs215',
  IncreaseDecreaseInOtherPayable: 'cfa12',
  IncreaseDecreaseInBusinessIncomeTaxPaid: 'cfa15',
  increaseDecreaseInInventories: 'cfa11',
  increaseDecreaseInPrepaidExpenses: 'cfa13',
  increaseDecreaseInTradingSecurities: 'cfa105',
  interestPaid: 'cfa14',
  otherReceiptsFromOperatingActivities: 'cfa16',
  otherPaymentsOnOperatingActivities: 'cfa17',
  netCashInflowsoutflowsFromInvestingActivies: 'cfa26',
  purchasesOfFixedAssetsAndOtherLongtermAssets: 'cfa19',
  ProceedsFromDisposalOfFixedAssets: 'cfa20',
  LoansGrantedPurchasesOfDebtInstruments: 'cfa21',
  collectionOfLoansProceedsFromSalesOfDebtsInstrument: 'cfa22',
  InvestmentsInOtherEntities: 'cfa23',
  ProceedsFromInvestmentInOtherEntities: 'cfa24',
  dividendsAndInterestReceived: 'cfa25',
  netCashInflowsoutflowsFromFinancingActivities: 'cfa34',
  proceedsFromIssueOfShares: 'cfa27',
  payMentsFroShareReturnsAndRepurchases: 'cfa28',
  proceedsFromLoans: 'cfa29',
  loansFromSettlementAssistanceFundReceived: 'cfs113',
  otherLoansReceived: 'cfs114',
  repaymentOfLoans: 'cfa30',
  loansPrincipalRepaidToSettlementAssistanceFund: 'cfs115',
  financialAssetsLoansPrincipalRepaid: 'cfs116',
  otherLoansPrincipalRepaid: 'cfs117',
  financialLeasePricipalPayments: 'cfa31',
  dividensPaid: 'cfa32',
  netIncreaseInCashAndCashEquivalents: 'cfa35',
  cashAndCashEquivalentsAtTheBeginningOfPeriod: 'cfa36',
  cashAndBankDepositAtTheBeginningOfThePeriod: 'cfs118',
  cashEquivalents: 'cfs120',
  effectOfForeignExchangeDifferences: 'cfa37',
  cashAndCashEquivalentsAtTheEndOfPeriod: 'cfa38',
};

export const CFCKRows = Object.keys(CKMapping).map(key => {
  const mappingValue = CKMapping[key];
  const defaultItem = {
    id: mappingValue,
    i18nKey: `cashFlowStatementCK.${key}`,
    level: LEVELS.PARENT,
  };

  if (
    [
      CKMapping.netIncreaseInCashAndCashEquivalents,
      CKMapping.cashAndCashEquivalentsAtTheEndOfPeriod,
    ].includes(mappingValue)
  ) {
    return defaultItem;
  }

  if (CKMapping.netCashInflowsoutflowsFromOperatingActivies === mappingValue) {
    return {
      ...defaultItem,
      children: [
        CKMapping.operatingProfitlossBeforeChangesInWc,
        CKMapping.changeInAssetsAndOperatingLiabilities,
        CKMapping.IncreaseDecreaseInReceivableFromSellingFvtplFinancialAssets,
        CKMapping.IncreaseDecreaseInReceivableFromInterestsOfFinancialAssets,
        CKMapping.IncreaseDecreaseInReceivableFromServicesRendered,
        CKMapping.IncreaseDecreaseInReceibleFromTransactionErrors,
        CKMapping.IncreaseDecreaseInOtherReceivables,
        CKMapping.IncreaseDecreaseInExpensePayableNotIncludingInterestExpense,
        CKMapping.IncreaseDecreaseInTradePayables,
        CKMapping.IncreaseDecreaseInPayablesToSecuritiesIssuers,
        CKMapping.IncreaseDecreaseInContributionToEmployeesWelfare,
        CKMapping.IncreaseDecreaseInTaxAndPayablesToAuthority,
        CKMapping.IncreaseDecreaseInPayablesToEmployees,
        CKMapping.IncreaseDecreaseInPayableAriseFromFinancialAssetTransactionErrors,
        CKMapping.IncreaseDecreaseInOtherPayable,
        CKMapping.IncreaseDecreaseInBusinessIncomeTaxPaid,
        CKMapping.increaseDecreaseInInventories,
        CKMapping.increaseDecreaseInPrepaidExpenses,
        CKMapping.increaseDecreaseInTradingSecurities,
        CKMapping.interestPaid,
        CKMapping.otherReceiptsFromOperatingActivities,
        CKMapping.otherPaymentsOnOperatingActivities,
      ],
    };
  }

  if (mappingValue === CKMapping.operatingProfitlossBeforeChangesInWc) {
    return {
      ...defaultItem,
      level: LEVELS.CHILD,
      children: [
        CKMapping.netProfitlossBeforeTax,
        CKMapping.adjustment,
        CKMapping.increaseInNoncashExpense,
        CKMapping.decreaseInNoncashRevenue,
      ],
    };
  }

  if (mappingValue === CKMapping.changeInAssetsAndOperatingLiabilities) {
    return {
      ...defaultItem,
      level: LEVELS.CHILD,
      children: [
        CKMapping.increaseDecreaseInFairValueThroughProfitAndLossFinancialAssets,
        CKMapping.increaseDecreaseInHeldToMarturityInvestments,
        CKMapping.increaseDecreaseInLoansGiven,
        CKMapping.increaseDecreaseInAvailableforsaleFinancialAssets,
        CKMapping.increaseDecreaseInOtherAssets,
        CKMapping.increaseDecreaseInReceivableFromSellingFinancialAssets,
        CKMapping.increaseDecreaseInFinancialAssetLoansAndFinancialLease,
        CKMapping.increaseDecreaseInFinancialAssetLoans,
        CKMapping.increaseDecreaseInCovertibleBondequityPortion,
        CKMapping.increaseDecreaseInIssuedBond,
        CKMapping.increaseDecreaseInBorrowingFromSettlementAssistanceFund,
      ],
    };
  }

  if (CKMapping.adjustment === mappingValue) {
    return {
      ...defaultItem,
      level: LEVELS.THREE,
      children: [
        CKMapping.depreciationAndAmortisation,
        CKMapping.amortisationOfGoodwill,
        CKMapping.provisions,
        CKMapping.unrealisedForeignExchangeGainloss,
        CKMapping.accruedExpenses,
        CKMapping.profitlossFromInvestingActivities,
        CKMapping.interestExpense,
        CKMapping.interestIncomeAndDividend,
        CKMapping.otherAdjustments,
      ],
    };
  }

  if (CKMapping.increaseInNoncashExpense === mappingValue) {
    return {
      ...defaultItem,
      level: LEVELS.THREE,
      children: [
        CKMapping.lossOnValuationOfFairValueThroughProfitlossFinancialAssets,
        CKMapping.lossFromFinancialAssetsSales,
        CKMapping.lossFromDerivatives,
        CKMapping.lossOnValuationOfAvailableForSaleFinancialAssets,
        CKMapping.decreaseInTheValueOfAvailableSalesAssets,
        CKMapping.lossOnValuationOfHeldToMarturityInvestments,
        CKMapping.lossOnTheDecreaseInValueOfLoansGiven,
        CKMapping.lossRegconizedWhenReclassificationOfAfsIsMadeAndFairValueIsUsedForRevaluation,
        CKMapping.lossFromDerivatives_22,
        CKMapping.lossFromSalesOfFixedAssets,
        CKMapping.decreaseInValueOfFixedAssets,
        CKMapping.provisionForDecreaseInValueOfLongtermFinancialInvestments,
        CKMapping.lossFromDisposalsOrSalesOfInvestmentInSubsidiariesAssociatesAndJointVentures,
        CKMapping.otherLoss,
      ],
    };
  }

  if (CKMapping.decreaseInNoncashRevenue === mappingValue) {
    return {
      ...defaultItem,
      level: LEVELS.THREE,
      children: [
        CKMapping.gainFromRevaluationOfFairValueThroughProfitAndLossFinancialAssets,
        CKMapping.gainFromRevaluationOfFairValueThroughProfitAndLossFinancialDebts,
        CKMapping.gainFromSalesOfAvailableForSaleAssets,
        CKMapping.reversalOfLossFromAvailableForSaleAssets,
        CKMapping.gainRecognizedWhenReclassificationOfAfsIsMadeAndFairValueIsUsedForRevaluation,
        CKMapping.gainFromDerivatives,
        CKMapping.gainFromTheDecreaseInValueOfLoansGiven,
        CKMapping.reversalOfProvision,
        CKMapping.gainFromSalesOfFixedAssetsAndProperties,
        CKMapping.gainFromDisposalsOrSalesOfInvestmentsInSubsidiariesAssociatesAndJointVentures,
        CKMapping.otherGain,
      ],
    };
  }

  if (CKMapping.changeInAssetsAndOperatingLiabilities === mappingValue) {
    return {
      ...defaultItem,
      level: LEVELS.THREE,
      children: [
        CKMapping.increaseDecreaseInFairValueThroughProfitAndLossFinancialAssets,
        CKMapping.increaseDecreaseInHeldToMarturityInvestments,
        CKMapping.increaseDecreaseInLoansGiven,
        CKMapping.increaseDecreaseInAvailableforsaleFinancialAssets,
        CKMapping.increaseDecreaseInOtherAssets,
        CKMapping.increaseDecreaseInReceivableFromSellingFinancialAssets,
        CKMapping.increaseDecreaseInFinancialAssetLoansAndFinancialLease,
        CKMapping.increaseDecreaseInFinancialAssetLoans,
        CKMapping.increaseDecreaseInCovertibleBondequityPortion,
        CKMapping.increaseDecreaseInIssuedBond,
        CKMapping.increaseDecreaseInBorrowingFromSettlementAssistanceFund,
      ],
    };
  }

  if (CKMapping.netCashInflowsoutflowsFromInvestingActivies === mappingValue) {
    return {
      ...defaultItem,
      children: [
        CKMapping.purchasesOfFixedAssetsAndOtherLongtermAssets,
        CKMapping.ProceedsFromDisposalOfFixedAssets,
        CKMapping.LoansGrantedPurchasesOfDebtInstruments,
        CKMapping.collectionOfLoansProceedsFromSalesOfDebtsInstrument,
        CKMapping.InvestmentsInOtherEntities,
        CKMapping.ProceedsFromInvestmentInOtherEntities,
        CKMapping.dividendsAndInterestReceived,
      ],
    };
  }

  if (
    CKMapping.netCashInflowsoutflowsFromFinancingActivities === mappingValue
  ) {
    return {
      ...defaultItem,
      children: [
        CKMapping.proceedsFromIssueOfShares,
        CKMapping.payMentsFroShareReturnsAndRepurchases,
        CKMapping.proceedsFromLoans,
        CKMapping.repaymentOfLoans,
        CKMapping.financialLeasePricipalPayments,
        CKMapping.dividensPaid,
      ],
    };
  }

  if (CKMapping.proceedsFromLoans === mappingValue) {
    return {
      ...defaultItem,
      level: LEVELS.CHILD,
      children: [
        CKMapping.loansFromSettlementAssistanceFundReceived,
        CKMapping.otherLoansReceived,
      ],
    };
  }

  if (CKMapping.repaymentOfLoans === mappingValue) {
    return {
      ...defaultItem,
      level: LEVELS.CHILD,
      children: [
        CKMapping.loansPrincipalRepaidToSettlementAssistanceFund,
        CKMapping.financialAssetsLoansPrincipalRepaid,
        CKMapping.otherLoansPrincipalRepaid,
      ],
    };
  }

  if (CKMapping.cashAndCashEquivalentsAtTheBeginningOfPeriod === mappingValue) {
    return {
      ...defaultItem,
      children: [
        CKMapping.cashAndBankDepositAtTheBeginningOfThePeriod,
        CKMapping.cashEquivalents,
        CKMapping.effectOfForeignExchangeDifferences,
      ],
    };
  }

  // Level three
  if (
    [
      CKMapping.loansPrincipalRepaidToSettlementAssistanceFund,
      CKMapping.financialAssetsLoansPrincipalRepaid,
      CKMapping.otherLoansPrincipalRepaid,
      CKMapping.loansFromSettlementAssistanceFundReceived,
      CKMapping.otherLoansReceived,
      CKMapping.netProfitlossBeforeTax,
      CKMapping.adjustment,
      CKMapping.increaseInNoncashExpense,
      CKMapping.decreaseInNoncashRevenue,
      CKMapping.increaseDecreaseInFairValueThroughProfitAndLossFinancialAssets,
      CKMapping.increaseDecreaseInHeldToMarturityInvestments,
      CKMapping.increaseDecreaseInLoansGiven,
      CKMapping.increaseDecreaseInAvailableforsaleFinancialAssets,
      CKMapping.increaseDecreaseInOtherAssets,
      CKMapping.increaseDecreaseInReceivableFromSellingFinancialAssets,
      CKMapping.increaseDecreaseInFinancialAssetLoansAndFinancialLease,
      CKMapping.increaseDecreaseInFinancialAssetLoans,
      CKMapping.increaseDecreaseInCovertibleBondequityPortion,
      CKMapping.increaseDecreaseInIssuedBond,
      CKMapping.increaseDecreaseInBorrowingFromSettlementAssistanceFund,
    ].includes(mappingValue)
  ) {
    return {
      ...defaultItem,
      level: LEVELS.THREE,
    };
  }

  // Level four
  if (
    [
      CKMapping.gainRecognizedWhenReclassificationOfAfsIsMadeAndFairValueIsUsedForRevaluation,
      CKMapping.gainFromRevaluationOfFairValueThroughProfitAndLossFinancialAssets,
      CKMapping.gainFromRevaluationOfFairValueThroughProfitAndLossFinancialDebts,
      CKMapping.gainFromSalesOfAvailableForSaleAssets,
      CKMapping.reversalOfLossFromAvailableForSaleAssets,
      CKMapping.gainFromDerivatives,
      CKMapping.gainFromTheDecreaseInValueOfLoansGiven,
      CKMapping.reversalOfProvision,
      CKMapping.gainFromSalesOfFixedAssetsAndProperties,
      CKMapping.gainFromDisposalsOrSalesOfInvestmentsInSubsidiariesAssociatesAndJointVentures,
      CKMapping.otherGain,
      CKMapping.increaseDecreaseInFairValueThroughProfitAndLossFinancialAssets,
      CKMapping.increaseDecreaseInHeldToMarturityInvestments,
      CKMapping.increaseDecreaseInLoansGiven,
      CKMapping.increaseDecreaseInAvailableforsaleFinancialAssets,
      CKMapping.increaseDecreaseInOtherAssets,
      CKMapping.increaseDecreaseInReceivableFromSellingFinancialAssets,
      CKMapping.increaseDecreaseInFinancialAssetLoansAndFinancialLease,
      CKMapping.increaseDecreaseInFinancialAssetLoans,
      CKMapping.increaseDecreaseInCovertibleBondequityPortion,
      CKMapping.increaseDecreaseInIssuedBond,
      CKMapping.increaseDecreaseInBorrowingFromSettlementAssistanceFund,
      CKMapping.lossOnValuationOfFairValueThroughProfitlossFinancialAssets,
      CKMapping.lossFromFinancialAssetsSales,
      CKMapping.lossFromDerivatives,
      CKMapping.lossOnValuationOfAvailableForSaleFinancialAssets,
      CKMapping.decreaseInTheValueOfAvailableSalesAssets,
      CKMapping.lossOnValuationOfHeldToMarturityInvestments,
      CKMapping.lossOnTheDecreaseInValueOfLoansGiven,
      CKMapping.lossRegconizedWhenReclassificationOfAfsIsMadeAndFairValueIsUsedForRevaluation,
      CKMapping.lossFromDerivatives_22,
      CKMapping.lossFromSalesOfFixedAssets,
      CKMapping.decreaseInValueOfFixedAssets,
      CKMapping.provisionForDecreaseInValueOfLongtermFinancialInvestments,
      CKMapping.lossFromDisposalsOrSalesOfInvestmentInSubsidiariesAssociatesAndJointVentures,
      CKMapping.otherLoss,
      CKMapping.depreciationAndAmortisation,
      CKMapping.amortisationOfGoodwill,
      CKMapping.provisions,
      CKMapping.unrealisedForeignExchangeGainloss,
      CKMapping.accruedExpenses,
      CKMapping.profitlossFromInvestingActivities,
      CKMapping.interestExpense,
      CKMapping.interestIncomeAndDividend,
      CKMapping.otherAdjustments,
    ].includes(mappingValue)
  ) {
    return {
      ...defaultItem,
      level: LEVELS.FOUR,
    };
  }

  return {
    ...defaultItem,
    level: LEVELS.CHILD,
  };
});
